import { EventPanelFormType } from '@mark43/cad-api';
import { useFormContext } from 'react-hook-form';
import { useCallback } from 'react';
import {
    EditableDrugsFormProperty,
    EditableFirearmFormProperty,
    EditableOtherItemsFormProperty,
} from './types';
import {
    getDefaultDrug,
    getDefaultFirearm,
    getDefaultOtherItem,
} from '../event-panel/event-panel-form/involved-person-vehicle-fields/property/property-helper';

export function useAddFirearmToForm() {
    const form = useFormContext<EventPanelFormType>();

    return useCallback(
        (propertyType: EditableFirearmFormProperty) => {
            const currentList = form.getValues()?.[propertyType];
            form.setValue(propertyType, [...currentList, getDefaultFirearm()]);
        },
        [form]
    );
}

export function useAddDrugsToForm() {
    const form = useFormContext<EventPanelFormType>();

    return useCallback(
        (propertyType: EditableDrugsFormProperty) => {
            const currentList = form.getValues()?.[propertyType];
            form.setValue(propertyType, [...currentList, getDefaultDrug()]);
        },
        [form]
    );
}

export function useAddOtherItemsToForm() {
    const form = useFormContext<EventPanelFormType>();

    return useCallback(
        (propertyType: EditableOtherItemsFormProperty) => {
            const currentList = form.getValues()?.[propertyType];
            form.setValue(propertyType, [...currentList, getDefaultOtherItem()]);
        },
        [form]
    );
}
